import React, { useState } from 'react'
import { useUnpaidCreditsStore } from '../../hooks'
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { createPortal } from 'react-dom';
import { Close } from 'src/icons/icons';
import { useMutation } from 'react-query';
import { Post } from 'src/apis/api';
import CustomButton from 'src/components/UI/customButton/customButton';
import { ResponseType } from 'src/types';
import { AxiosResponse } from 'axios';
import { toast } from 'react-toastify';
import Loading from 'src/components/Loading';
import { useNavigate } from 'react-router-dom';
import { createFormData } from 'src/utils/new';
import { useWallet } from 'src/hooks';


interface FormType {
    file?: File,
    desc?: string,
    method: 'online' | 'offline' | 'wallet'
}

const InfoItem = ({ title, number }: { title: string, number: number }) => {

    return <div className='rounded-lg flex flex-col gap-2 p-4 bg-[#F2F1F6] text-center flex-1 whitespace-nowrap'>

        <span>{title}</span>

        <span className='font-bold text-primary-500' dir='ltr'>{number.toLocaleString()} IRT</span>
    </div>
}

export const Pay = () => {


    const { selectedItems } = useUnpaidCreditsStore()

    const [data, setData] = useState<FormType>({ method: 'online', desc: '' })

    const { data: walletData, isLoading: loadingWallet } = useWallet()


    const { mutate, isLoading } = useMutation<any, { f: string }, FormType, FormType>({
        mutationFn: (data) => {

            const formData = new FormData()

            formData.append('form', 'store_pay')
            formData.append('method', data.method)

            if (data.file)
                formData.append('file', data.file)

            if (data.desc)
                formData.append('desc', data?.desc)

            selectedItems.forEach((item, index) => {
                formData.append(`credits[${item.credit.id}][credit_id]`, item.credit.id.toString())
                item.crews.forEach((crewItem, index) => {
                    formData.append(`credits[${item.credit.id}][crews][${index + 1}]`, crewItem)
                })



            })


            // return Post('agent/transactions/settlement/pay', { ...data, form: 'store_pay', credits: selectedItems.map(i => i.credit) })
            return Post('agent/transactions/settlement/pay', formData)
        },
        mutationKey: ['PayCredits'],
        onSuccess: (res) => {
            if (res?.details?.url) {
                toast.success(t('RedirectingToGateway'))
                setOpen(false)
                return window.location.assign(res?.details?.url)
            }
            {

                toast.success(res?.msg);
                setOpen(false)
                return
            }
        },
        onError: (error: any) => {
            toast.error(error?.data?.message || error?.data?.msg);
        },
    })

    const { t } = useTranslation();


    const [isOpen, setOpen] = useState<boolean>(false)


    const totalPrice = selectedItems.reduce((pv, cv) => pv += (cv?.credit?.transaction.item?.visa?.price ?? 0) * cv.crews.length, 0)

    const handleMutate = () => {
        if (data.method == 'offline' && !data.file) {
            return toast.error(t('NeedRecipeForOfflinePay'))
        }
        const { file, ...rest } = data
        mutate({ ...rest, ...(rest.method == 'offline' ? ({ file }) : ({})) })
    }


    const walletBalance = (walletData as any)?.details?.data?.amount
    
    const crewsLength = selectedItems.reduce ( (pv , cv) => pv+=cv?.crews?.length , 0)

    return (
        <>
            <button className={clsx('bg-primary-300 text-white py-2 px-8 text-center max-w-fit  text-lg rounded-lg cursor-pointer',crewsLength == 0 && 'grayscale')} disabled={crewsLength==0} onClick={() => setOpen(true)}>
                {t('Pay')}  ( {crewsLength}  {t('CrewVisa')} )
            </button>


            {isOpen && createPortal(<div className={clsx('fixed top-0 left-0 h-full w-full backdrop-brightness-50 z-40 flex flex-row justify-center items-center', !isOpen ? 'opacity-0' : ' opacity-100')}>
                <div className={clsx('flex flex-col gap-5 transition-all duration-300 bg-white min-w-96 max-w-[80vw] w-[55vw] lg:max-w-[550px] rounded-2xl border p-4 relative max-h-[90vh] overflow-auto', !isOpen ? 'translate-y-full' : 'translate-y-0')}>

                    <div className='absolute left-4 top-4 cursor-pointer' onClick={() => setOpen(false)}> <Close color='gray' /></div>

                    <span className='text-lg '>{t('Pay')} {t('VisasDebt')}  ( {selectedItems.length} {t('CrewVisa')} )</span>

                    <div className='h-[1px] w-full bg-gray-200'></div>

                    <div className='flex flex-row gap-3 items-center '>


                        {data.method == 'wallet' && <InfoItem
                            title={t('WalletBallance')}
                            number={walletBalance}
                        />}

                        <InfoItem
                            title={t('VisasDebtAmount')}
                            number={totalPrice}
                        />


                        <InfoItem
                            title={t('Fee')}
                            number={totalPrice - (data.method == 'wallet' ? walletBalance : 0)}
                        />
                    </div>


                    <span>{t('SelectPayMethod')}</span>

                    <div className='flex flex-row gap-5 items-center'>

                        <label className='flex flex-row gap-2 items-center cursor-pointer'>
                            <input type='radio' checked={data.method == 'online'} onChange={({ target: { checked } }) => checked ? setData({ ...data, method: 'online' }) : undefined} />
                            <span>{t('Online')} ({t('PaymentGateway')})</span>
                        </label>

                        <label className='flex flex-row gap-2 items-center cursor-pointer'>
                            <input type='radio' checked={data.method == 'wallet'} onChange={({ target: { checked } }) => checked ? setData({ ...data, method: 'wallet' }) : undefined} />
                            <span>{t('Wallet')}</span>
                        </label>



                        <label className='flex flex-row gap-2 items-center cursor-pointer'>
                            <input type='radio' checked={data.method == 'offline'} onChange={({ target: { checked } }) => checked ? setData({ ...data, method: 'offline' }) : undefined} />
                            <span>{t('Offline')} ({t('SendPictureOfRecipe')})</span>
                        </label>

                    </div>

                    <textarea
                        className='outline-none max-h-16 resize-none border rounded-lg text-sm'
                        value={data.desc}
                        onChange={({ target: { value } }) => setData({ ...data, desc: value })}
                        placeholder={t('Description')}
                    />

                    {data.method == 'offline' && <label className='flex flex-row gap-2 items-center border rounded-lg px-3 py-1 cursor-pointer'>
                        <span className='text-sm font-bold'>{t('PictureOfRecipe')}</span>
                        <input accept='image/*' type='file' onChange={({ target: { files } }) => files?.[0] instanceof File ? setData({ ...data, file: files[0] }) : undefined} />
                    </label>}
                    <div className='flex flex-row justify-end gap-2 '>
                        <button className='text-primary-300 bg-primary-200 py-4 px-8 rounded-lg text-center cursor-pointer flex justify-center flex-row' onClick={()=>setOpen(false)}>
                            {t('Refuse')}
                        </button>


                        <button className={clsx('bg-primary-300 text-white py-4 px-8 rounded-lg text-center cursor-pointer flex justify-center flex-row', isLoading && 'grayscale')} disabled={isLoading} onClick={handleMutate} >
                            {isLoading ? <Loading /> : `${t('Pay')} (${totalPrice.toLocaleString()} ${t('Toman')})`}

                        </button>
                    </div>
                    {/* 
                    <CustomButton onClick={() => mutate(data)} styles={undefined} title={'Pay'}>

                    </CustomButton> */}
                </div>
            </div>, document.body

            )}
        </>
    )
}
